import React, { useState, useEffect, useContext } from "react";
import { MeteoInfoDataContext } from "./context";

import { getMeteoInfoData } from "../services/services";
import { useAllContexts } from "./useAllContexts";
import {
  filterDataSingleValueReturn,
  filterDataWithMultipleDirectives,
} from "../components/Map/helpers";

const MeteoInfoProvider = ({ children }) => {
  const [meteoInfoData, setMeteoInfoData] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [meteoInfoFilters, setMeteoInfoFilters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshFilters, setRefreshFilters] = useState(false);

  const handleMeteoFilterChange = (filterId, filterValue) => {
    const updatedFilters = meteoInfoFilters.map((filter) =>
      filter.id === filterId ? { ...filter, isActive: filterValue } : filter
    );
    setMeteoInfoFilters(updatedFilters);
    setRefreshFilters(!refreshFilters);
  };

  const handleDataFiltering = (data) => {
    const activeFilters = filterDataSingleValueReturn(
      meteoInfoFilters,
      "isActive",
      "title"
    );

    if (activeFilters.length === 0) {
      setFilteredData(data);
    } else {
      const filteredData = data.filter((item, id) => {
        const itemDetails = item.details.map(
          (detail) => detail.sensorvar_description
        );
        for (let detailName of itemDetails) {
          if (activeFilters.includes(detailName)) {
            return item;
          }
        }
      });

      setFilteredData(filteredData);
    }
  };

  useEffect(() => {
    const fetchMeteoInfo = async () => {
      const meteoInfo = await getMeteoInfoData({ lang: "el" })
        .then((response) => {
          if (response?.length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
          return error;
        });

      const tempMeteoVariables = [];

      for (let meteoItem of meteoInfo) {
        for (let item of meteoItem.details) {
          if (!tempMeteoVariables.includes(item.sensorvar_description)) {
            tempMeteoVariables.push(item.sensorvar_description);
          }
        }
      }

      const formattedMeteoVariables = tempMeteoVariables.map((variable, id) => {
        return {
          title: variable,
          isActive: false,
          id,
        };
      });

      setMeteoInfoData(meteoInfo);
      setMeteoInfoFilters(formattedMeteoVariables);
      handleDataFiltering(meteoInfo);
    };

    if (!meteoInfoData) {
      fetchMeteoInfo();
    } else {
      handleDataFiltering(meteoInfoData);
    }
  }, [refreshFilters]);

  return (
    <MeteoInfoDataContext.Provider
      value={{
        meteoInfoData: filteredData,
        meteoInfoFilters,
        setMeteoInfoData,
        handleMeteoFilterChange,
        loading,
        error,
      }}
    >
      {children}
    </MeteoInfoDataContext.Provider>
  );
};

export default MeteoInfoProvider;
